import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CONTACT, INSTAGRAM_PHOTOS } from "@/data/content";

export const InstagramStrip = () => (
  <section data-testid="instagram-strip" className="bg-white py-16 lg:py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-brand">
              <Instagram className="h-4 w-4" />
              Instagram
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Son işlerimiz akışta
            </h2>
            <p className="mt-3 text-lg text-slate-600">
              Günlük işçiliğimizden kareler —{" "}
              <span className="font-bold text-slate-900">{CONTACT.instagramHandle}</span> hesabımızdan.
            </p>
          </div>
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF] px-6 py-3 text-sm font-bold text-white shadow-soft transition-all hover:-translate-y-0.5 hover:shadow-lift"
          >
            <Instagram className="h-4 w-4" />
            Takip Et
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div
          className="mt-10 flex gap-4 overflow-x-auto pb-3 snap-x snap-mandatory lg:grid lg:grid-cols-6 lg:overflow-visible"
          data-testid="instagram-grid"
        >
          {INSTAGRAM_PHOTOS.map((p, i) => (
            <a
              key={p.src}
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-item-${i + 1}`}
              className="group relative aspect-square w-64 shrink-0 snap-start overflow-hidden rounded-2xl shadow-soft lg:w-auto"
            >
              <img
                src={p.src}
                alt={p.caption}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 flex items-end bg-gradient-to-t from-slate-900/70 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <span className="flex w-full items-center justify-between gap-2 p-3">
                  <span className="text-xs font-bold text-white drop-shadow">{p.caption}</span>
                  <Instagram className="h-4 w-4 shrink-0 text-white" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default InstagramStrip;
